import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import { useGetQuantifyFormulaDisplayName } from '@modules/quantify/hooks';
import { Stack, Typography } from '@mui/material';

interface QuantifyFormulaNameWithValueProps {
  value: number;
}

export function QuantifyFormulaNameWithValue({
  value,
}: QuantifyFormulaNameWithValueProps) {
  const { formulaDisplayName, isLoading } = useGetQuantifyFormulaDisplayName({
    shouldIncludeGroupByName: true,
  });

  return (
    <Stack direction="column" spacing={1} sx={{ px: 1.5, pt: 1 }}>
      <LoadingTypography
        isLoading={formulaDisplayName ? false : isLoading}
        variant="body2"
        color="text.primary"
        sx={{
          maxWidth: `250px`,
          wordWrap: 'break-word',
        }}
      >
        {formulaDisplayName}
      </LoadingTypography>
      <Typography variant="body2" color="text.secondary">
        {value}
      </Typography>
    </Stack>
  );
}
